/* eslint-disable react/no-array-index-key */
/* eslint-disable max-len */
// import { ExpansionPanel } from '@ferris/react/components/expansion-panel';
import React, { forwardRef } from 'react';
import PropTypes from 'prop-types';
import parse from 'html-react-parser';
import { Icon } from '@ferris/react';
import { sanitizeHtml } from '../../utils/HtmlUtil';
import Accordion from '../../ui/components/accordion';

function processAnswer(answer = '') {
    if (!answer || typeof answer !== 'string') return '';

    // Preserve <br> and custom <tb> marker across sanitization by substituting placeholders
    const BR_PLACEHOLDER = '%%%__BR__%%%';
    const TB_PLACEHOLDER = '%%%__TB__%%%';

    const prepped = answer.replace(/<br\s*\/?\s*>/gi, BR_PLACEHOLDER).replace(/<tb>/gi, TB_PLACEHOLDER);

    // Sanitize incoming HTML to remove unsafe content and normalize other breaks
    const sanitized = sanitizeHtml(prepped);

    // Ensure anchors open in new tab and have rel protections if not already present.
    const anchored = sanitized.replace(/<a\b([^>]*)>/gi, (match, attrs = '') => {
        // If a target is already present, leave the tag as-is
        if (/\btarget\s*=/.test(attrs)) return `<a${attrs}>`;

        // Check if this is a relative/hash link - if so, don't add target="_blank"
        const hrefMatch = attrs.match(/href\s*=\s*["']([^"']*)/i);
        if (hrefMatch && hrefMatch[1] && hrefMatch[1].startsWith('#')) {
            return `<a${attrs}>`;
        }

        // Ensure rel contains noopener and noreferrer
        if (/\brel\s*=/.test(attrs)) {
            // Append missing tokens if necessary
            const relAttr = attrs.replace(/rel\s*=\s*"([^"]*)"/i, (m, relVal) => {
                const parts = relVal.split(/\s+/).filter(Boolean);
                if (!parts.includes('noopener')) parts.push('noopener');
                if (!parts.includes('noreferrer')) parts.push('noreferrer');
                return `rel="${parts.join(' ')}"`;
            });
            return `<a${relAttr} target="_blank">`;
        }

        // No rel present: add rel and target
        return `<a${attrs} target="_blank" rel="noopener noreferrer">`;
    });

    // Restore the <tb> placeholder to an actual span and BR placeholder to <br />
    const restored = anchored.replace(new RegExp(TB_PLACEHOLDER, 'g'), '<span class="tab-space"></span>')
        .replace(new RegExp(BR_PLACEHOLDER, 'g'), '<br />');

    // Return parsed HTML (no extra wrapper) so shallow render has a single top-level div
    return parse(restored);
}

const AccordionIcon = (
    <Icon
        name="keyboard-arrow-down"
    />
);

const CustomExpansionPanel = forwardRef(({ onToggle, question, answer }, ref) => (
    <div ref={ref} className="faq-expansion-panel" tabIndex={-1}>
        <Accordion
            htmlCommonProps={{
                tabIndex: -1,
                itemScope: true,
                itemProp: 'acceptedAnswer',
                itemType: 'https://schema.org/Answer'
            }}
            customClass="expansion-panel"
            title={(
                parse(sanitizeHtml(question || ''))
            )}
            htmlTitleProps={{
                itemProp: 'name',
                'aria-label': question
            }}
            onToggle={onToggle}
            ref={ref}
            icon={AccordionIcon}
        >
            <span className="answer" itemProp="text">
                {processAnswer(answer || '')}
            </span>
        </Accordion>
    </div>
));

CustomExpansionPanel.propTypes = {
    onToggle: PropTypes.func.isRequired,
    question: PropTypes.string.isRequired,
    answer: PropTypes.string.isRequired
};

// export default CustomExpansionPanel;
export default CustomExpansionPanel;
